import firebase from 'firebase';
import $ from 'jquery';
import _ from 'lodash';

import Events from '../_utils/events.js';

import playersService from './players.service.js';

class GroupsService extends Events {

	toArrayWithIds(__groups) {
		let
		groups = [];

		// Is a Firebase Object
		if (__groups.forEach) {
			__groups.forEach(__group => {
				groups.push(_.extend({groupId: __group.key}, __group.val()));
			});
		}
		// Is a common object
		else {
			_.each(__groups, (group, groupKey) => {
				groups.push(_.extend({groupId: groupKey}, group));
			});
		}

		return groups;
	}

	getGroupStandings(matches, players) {
		let 
		groupStandings = {},
		groupStandingsArray;

		//Initialize groupStandings array
		_.forEach(players, player => {
			groupStandings[player.playerId] = {
				matchesPlayed: 0,
				matchesWon: 0,
				totalGamesWon: 0,
				totalGamesLost: 0,
				totalPoints: 0,
				tieSolver: 0,
				unsolvableTie: false,
				playerId: player.playerId
			};
		});

		let counter = 1;

		_.forEach(matches, match => {
			
			try {
				if (match.player1.games < 0 || match.player2.games < 0) {
					groupStandings[match.player1.playerId].totalGamesWon -= 1;
					groupStandings[match.player1.playerId].totalGamesLost += 1;
					groupStandings[match.player2.playerId].totalGamesWon -= 1;
					groupStandings[match.player2.playerId].totalGamesLost += 1;
					
					groupStandings[match.player1.playerId].totalPoints -= 1;
					groupStandings[match.player2.playerId].totalPoints -= 1;

				} else {
					groupStandings[match.player1.playerId].totalGamesWon += match.player1.games;
					groupStandings[match.player1.playerId].totalGamesLost += match.player2.games;
					groupStandings[match.player2.playerId].totalGamesWon += match.player2.games;
					groupStandings[match.player2.playerId].totalGamesLost += match.player1.games;

					if (match.player1.games > match.player2.games) {
						groupStandings[match.player1.playerId].matchesWon += 1;
						groupStandings[match.player1.playerId].totalPoints += 3;
					} else if(match.player1.games < match.player2.games) {
						groupStandings[match.player2.playerId].matchesWon += 1;
						groupStandings[match.player2.playerId].totalPoints += 3;
					}
				}

				if (match.player1.games !== 0 || match.player2.games !== 0) {
					groupStandings[match.player1.playerId].matchesPlayed += 1;
					groupStandings[match.player2.playerId].matchesPlayed += 1;
				}
			} catch (e) {
				window.console.error('Error processing match:');
				window.console.error(match);

				throw(new Error('Error processing match'));
			}

		});

		_.forEach(groupStandings, playerStanding => {
			playerStanding.gamesDifference = playerStanding.totalGamesWon - playerStanding.totalGamesLost;
		});

		//Orders and returns an array
		groupStandingsArray = _.orderBy(groupStandings, 
			['totalPoints', 'matchesWon', 'matchesPlayed', 'gamesDifference', 'totalGamesWon', 'totalGamesLost'], 
			['desc', 'desc', 'desc', 'desc', 'desc', 'asc']
		);

		groupStandingsArray = this.solveGroupStandingsTies(groupStandingsArray, matches);

		return groupStandingsArray;
	}

	solveGroupStandingsTies(groupStandings, matches) {
		let 
		count = 1,
		tieRange = [-1, -1],
		solvedTiedStanding;
		
		while (count < groupStandings.length) {
			if (this.isTiedStanding(groupStandings[count-1], groupStandings[count])) {
				tieRange[0] = tieRange[0] !== -1 ? tieRange[0] : count-1;
				tieRange[1] = count;
			} else if (tieRange[0] !== -1) {
				solvedTiedStanding = this.solveTiedStanding(groupStandings.slice(tieRange[0], (tieRange[1]+1) ), matches);
				groupStandings.splice(tieRange[0], (tieRange[1]+1) - tieRange[0], ...solvedTiedStanding);
				tieRange = [-1, -1];
			}
			count++;
		}

		return groupStandings;
	}

	isTiedStanding(p1S, p2S) {
		if (
			(p1S.matchesPlayed > 0) && (p2S.matchesPlayed > 0) && (p1S.totalPoints === p2S.totalPoints) && 
			(p1S.matchesWon === p2S.matchesWon) && (p1S.matchesPlayed === p2S.matchesPlayed) &&
			(p1S.totalGamesWon === p2S.totalGamesWon) && (p1S.totalGamesLost === p2S.totalGamesLost)
		) {
			return true;
		}

		return false;
	}

	solveTiedStanding(tiedStandings, matches) {
		//TODO: add algorithm to solve tiedStandings
		let 
		tiedPlayers = tiedStandings.map(playerStanding => {
				return playerStanding.playerId;
			}),

		tiedRelatedMatches = _.filter(matches, match => {
				if (
					(tiedPlayers.indexOf(match.player1.playerId) !== -1) &&
					(tiedPlayers.indexOf(match.player2.playerId) !== -1)
				) {
					return true;
				}

				return false;
			});

		tiedRelatedMatches.forEach(match => {
			let 
			winnerStanding,
			winner = match.player1.games > match.player2.games ? match.player1.playerId : 
				match.player1.games < match.player2.games ? match.player2.playerId : 
				undefined;

			if (winner) {
				winnerStanding = _.find(tiedStandings, standing => {
					return standing.playerId === winner;
				});

				winnerStanding.tieSolver++;
			}
		});

		tiedStandings = _.orderBy(tiedStandings, ['tieSolver'], ['desc']);

		let count = 1;

		while (count < tiedStandings.length) {
			if (tiedStandings[count].tieSolver === tiedStandings[count-1].tieSolver) {
				tiedStandings[count].unsolvableTie = tiedStandings[count-1].unsolvableTie = true;
			}
			count++;
		}

		return tiedStandings;
	}

	generateGroupMatches(group, groupId, players) {
		let groupMatches = [];
		for (let i=0; i<players.length-1; i++) {
			for (let j = i+1; j<players.length; j++) {
				groupMatches.push({
					groupId: groupId,
					player1: {
						games: 0,
						playerId: players[i].playerId
					},
					player2: {
						games: 0,
						playerId: players[j].playerId
					}
				});
			}
		}

		return groupMatches;
	}


	doGroupsPromotions(__groups, __players, __matches) {
		
		let
		sortedGroups = this.toArrayWithIds(__groups).sort((a,b) => a.rank > b.rank),
		players = playersService.toArrayWithIds(__players),
		matches = __matches.val(),

		roundPromises = [];

		for (let i=0; i<sortedGroups.length; i++) {
			/* jshint loopfunc: true */
			sortedGroups[i].playerStandings = this.getGroupStandings(
				_.filter(matches, match => match.groupId === sortedGroups[i].groupId), 
				_.filter(players, player => player.groupId === sortedGroups[i].groupId)
			);
			
			
			//Don't do it for first group, as players don't promote from there
			if (i > 0) {
				let
				group = sortedGroups[i],
				prevGroup = sortedGroups[i-1],
				groupPlayers = group.playerStandings,
				prevGroupPlayers = prevGroup.playerStandings,
				minPlayers = Math.min(prevGroupPlayers.length, groupPlayers.length),

				groupPromises = [];
				roundPromises[i-1] = $.Deferred();

				switch (minPlayers) {
					case 3: case 4: case 5: {
						for (let j=0; j<2; j++) {groupPromises[j] = $.Deferred();}
						this.updatePlayerGroup(prevGroupPlayers[prevGroupPlayers.length-1].playerId, group.groupId)
							.then(() => groupPromises[0].resolve())
							.catch(() => groupPromises[0].reject());
						this.updatePlayerGroup(groupPlayers[0].playerId, prevGroup.groupId)
							.then(() => groupPromises[1].resolve())
							.catch(() => groupPromises[1].reject());
						break;
					}
					case 6: case 7: {
						for (let j=0; j<4; j++) {groupPromises[j] = $.Deferred();}
						this.updatePlayerGroup(prevGroupPlayers[prevGroupPlayers.length-1].playerId, group.groupId)
							.then(() => groupPromises[0].resolve())
							.catch(() => groupPromises[0].reject());
						this.updatePlayerGroup(prevGroupPlayers[prevGroupPlayers.length-2].playerId, group.groupId)
							.then(() => groupPromises[1].resolve())
							.catch(() => groupPromises[1].reject());
						this.updatePlayerGroup(groupPlayers[0].playerId, prevGroup.groupId)
							.then(() => groupPromises[2].resolve())
							.catch(() => groupPromises[2].reject());
						this.updatePlayerGroup(groupPlayers[1].playerId, prevGroup.groupId)
							.then(() => groupPromises[3].resolve())
							.catch(() => groupPromises[3].reject());
						break;
					}
				}

				$.when.apply($, groupPromises).then(() => {
					roundPromises[i-1].resolve();
				});
			}

			/* jshint loopfunc: false */
		}

		return $.when.apply($, roundPromises);
	}

	updatePlayerGroup(playerId, groupId) {
		return firebase.database().ref('/players/' + playerId).update({groupId: groupId});
	}

}

let groupsService = new GroupsService();

export default groupsService;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/_services/groups.service.js